import React, { useState } from 'react';
import "./frezz.css";
import { post_order } from '../../services/services';

export const FREZZ = () => {

  const [name, setname]=useState("");
  const [tel, settel]=useState("");
  const [email, setemail]=useState("");
  const [code, setcode]=useState("");
  const [msj, setmsj]=useState("");



  const sendreport = async() =>{

    if(email === "" || code === "" || tel === "" || msj === "" || name === ""){
        alert("Datos faltantes en el formulario");
        return null;
    }
    if(code.length < 6){
        alert("El código de barras debe tener 6 digitos");
        return null;
    }

    var data = {
        email: email,
        id_freezer: code,
        message: msj,
        name: name,
        order: "",
        phone: tel,
        type: "reportar_congelador"
    }

    try{
        const d = await post_order(data);
        console.log(d);
        setname("");
        setemail("");
        setcode("");
        setmsj("");
        settel("");
        alert("Reporte enviado con éxito");
    }catch(err){
        console.log(err);
    }
  }

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,6}$/.test(value)) {
      setcode(value);
    }
  };

  return (
    <div className='frezz-container'>
        <div className='frezz-content'>
            <div className='frezz-forms'>
                <h2>Reportar Congelador</h2>
                <forms>
                    <input 
                        placeholder='Nombre'
                        value={name}
                        onChange={(e)=>setname(e.target.value)}
                    ></input>
                    <input
                        placeholder='Teléfono'
                        value={tel}
                        maxLength="10"
                        pattern="\d*"
                        onChange={(e)=>settel(e.target.value)}
                    ></input>
                    <input
                        placeholder='Correo Electrónico'
                        value={email}
                        onChange={(e)=>setemail(e.target.value)}
                    ></input>
                    <input
                        placeholder='Código de Barras del Congelador (6 digitos)'
                        value={code}
                        // onChange={(e)=>setcode(e.target.value)}
                        onChange={handleInputChange}
                        maxLength="6"
                        pattern="\d*"
                    ></input>
                    <textarea
                       placeholder='Descripción del problema'
                       value={msj}
                       onChange={(e)=>setmsj(e.target.value)}
                    >
                    </textarea>

                </forms>
                <button onClick={()=>sendreport()}>REPORTAR</button>
            </div>

        </div>
    </div>
  )
}
